import Header50 from './Header50'
export default Header50
